module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("资源位管理 / 操作")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "advert-popup-form",
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "start-placeholder": "开始日期",
      "range-separator": "至",
      "end-placeholder": "结束日期",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.daterange),
      callback: function($$v) {
        _vm.$set(_vm.formData, "daterange", $$v)
      },
      expression: "formData.daterange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "位置类型",
      "prop": "positionType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类型",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.positionType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "positionType", $$v)
      },
      expression: "formData.positionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "进展banner",
      "value": 9
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页活动信息栏",
      "value": 13
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页宣传栏",
      "value": 14
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我的banner",
      "value": 15
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "排行榜banner",
      "value": 19
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支付宝小程序首页banner",
      "value": 21
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支付宝小程序我的banner",
      "value": 22
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "广场推荐banner",
      "value": 23
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本之前的发现频道",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跑步结束banner",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动音乐顶部",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页-为你推荐",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "社区-动态",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本及之后的发现频道",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "问卷调查",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动banner",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片1",
      "value": 10
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片2",
      "value": 11
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片3",
      "value": 12
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页摩西",
      "value": 20
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序顶部banner轮播",
      "value": 16
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序banner",
      "value": 17
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序底部banner列表",
      "value": 18
    }
  })], 1)], 1), _vm._v(" "), (![10, 11, 12, 13, 14].includes(_vm.formData.positionType)) ? _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 5,
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.orderNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "orderNum", $$v)
      },
      expression: "formData.orderNum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.positionType) ? _c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "bannerImage"
    }
  }, [_c('SUpload', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=8",
      "accept": "image/*",
      "type": "drag",
      "size": [9, 8, 15, 2, 23].includes(_vm.formData.positionType) ? 300 : 0,
      "show-file-list": false
    },
    model: {
      value: (_vm.formData.bannerImage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bannerImage", $$v)
      },
      expression: "formData.bannerImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n          " + _vm._s(_vm.uploadImgTips) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击资源",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择点击资源",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无跳转",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有文章",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有话题",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至URL",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至已有活动",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至微信小程序",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至音频",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至支付宝小程序",
      "value": 9
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至商城",
      "value": 10
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至兑吧",
      "value": 11
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至陆基金",
      "value": 12
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跳转至摩西广告",
      "value": 13
    }
  })], 1)], 1), _vm._v(" "), ([1, 2].includes(_vm.formData.type)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.formData.type === 1 ? '文章ID' : '话题ID',
      "prop": "targetId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.targetId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "targetId", $$v)
      },
      expression: "formData.targetId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ([5, 6, 10, 11, 12, 13].includes(_vm.formData.type)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.formData.type === 5 ? 'H5' : '活动链接',
      "prop": "targetUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "targetUrl", $$v)
      },
      expression: "formData.targetUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), ([7, 9].includes(_vm.formData.type)) ? _c('el-form-item', {
    attrs: {
      "label": "小程序原始ID",
      "prop": "miniId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.miniId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "miniId", $$v)
      },
      expression: "formData.miniId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ([7, 9].includes(_vm.formData.type)) ? _c('el-form-item', {
    attrs: {
      "label": "小程序路径",
      "prop": "miniPath"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.miniPath),
      callback: function($$v) {
        _vm.$set(_vm.formData, "miniPath", $$v)
      },
      expression: "formData.miniPath"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.type === 8) ? [_c('el-form-item', {
    attrs: {
      "label": "专辑ID",
      "prop": "audioID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.audioID),
      callback: function($$v) {
        _vm.$set(_vm.formData, "audioID", $$v)
      },
      expression: "formData.audioID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主播名称",
      "prop": "audioNickName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.audioNickName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "audioNickName", $$v)
      },
      expression: "formData.audioNickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单曲数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.audioCount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "audioCount", $$v)
      },
      expression: "formData.audioCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否付费"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.audioIsPaid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "audioIsPaid", $$v)
      },
      expression: "formData.audioIsPaid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1)] : _vm._e(), _vm._v(" "), ([5, 7, 9].includes(_vm.formData.type)) ? _c('el-form-item', {
    staticClass: "popup-prompt-form-item",
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_vm._v("\n          " + _vm._s(_vm.formData.isPopup) + "\n          "), _c('el-radio-group', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isPopup", $$v)
      },
      expression: "formData.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.formData.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "popupContent", $$v)
      },
      expression: "formData.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    on: {
      "change": _vm.changeCampus
    },
    model: {
      value: (_vm.formData.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "applicableCampus", $$v)
      },
      expression: "formData.applicableCampus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    model: {
      value: (_vm.formData.platform),
      callback: function($$v) {
        _vm.$set(_vm.formData, "platform", $$v)
      },
      expression: "formData.platform"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": -1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("安卓")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": !_vm.isOperable
    }
  }, [_vm._v("鸿蒙")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.formData.applicableCampus ? '应用学校' : '屏蔽学校',
      "required": _vm.formData.applicableCampus ? true : false,
      "prop": "rootUnids"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择学校",
      "filterable": "",
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.schoolData),
      callback: function($$v) {
        _vm.schoolData = $$v
      },
      expression: "schoolData"
    }
  }, _vm._l((_vm.schoolDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isOperable
    },
    on: {
      "click": _vm.clickAddSchools
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.formData.rootUnids), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "card-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close",
        "disabled": !_vm.isOperable
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteSchools(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n          共计" + _vm._s(_vm.formData.rootUnids.length) + "所学校\n        ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告曝光代码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "disabled": !_vm.isOperable
    },
    model: {
      value: (_vm.formData.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.formData, "adExposingCodes", $$v)
      },
      expression: "formData.adExposingCodes"
    }
  })], 1)], 2)], 1), _vm._v(" "), (_vm.isOperable) ? _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave(1)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave(2)
      }
    }
  }, [_vm._v("保存并发布")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d9e8860!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/ResourceSpace/ResourceDetail.vue
// module id = 1101
// module chunks = 0